export function downloadAsCSV(data: unknown[][], title: string): void {
  const content = data
    .map((row) =>
      row
        .map(String)
        .map((v) => v.replace(/"/g, '""'))
        .map((v) => `"${v}"`)
        .join(",")
    )
    .join("\n");

  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const pom = document.createElement("a");
  pom.href = url;
  pom.setAttribute("download", `${title}.csv`);
  pom.click();
}
